var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13255_86623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52447 3.08156C7.67415 2.6209 8.32585 2.6209 8.47553 3.08156L9.09607 4.99139C9.29688 5.60943 9.87282 6.02786 10.5227 6.02786H12.5308C13.0151 6.02786 13.2165 6.64767 12.8247 6.93237L11.2001 8.11271C10.6743 8.49468 10.4543 9.17173 10.6552 9.78976L11.2757 11.6996C11.4254 12.1602 10.8981 12.5433 10.5063 12.2586L8.88168 11.0783C8.35595 10.6963 7.64405 10.6963 7.11832 11.0783L5.49372 12.2586C5.10187 12.5433 4.57463 12.1603 4.7243 11.6996L5.34484 9.78976C5.54566 9.17173 5.32567 8.49468 4.79994 8.11271L3.17534 6.93237C2.78348 6.64767 2.98487 6.02786 3.46923 6.02786H5.47735C6.12719 6.02786 6.70312 5.60942 6.90393 4.99139L7.52447 3.08156Z",
    stroke: "#404040",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#404040"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13255_86623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c4beccba88982d640e8f6424450cfabc.svg";
export { ForwardRef as ReactComponent };